import axios from "@/utils/request";
import { snkd } from "@/api/api";
import { getStorage } from "@/utils/storage";

//员工角色
export const getListByMissionCharge = (params) => {
  return axios.post(snkd.user.role.listByMissionCharge, params);
};

//添加操作人
export const addByMission = (params) => {
  return axios.post(snkd.user.company.addByMission, params);
};

// 获取操作人列表
export const getOperateList = (params) => {
  return axios.post(snkd.user.user.operateList, params);
};

// 获取企业信息
export const getCompanyInfo = (params) => {
  return axios.post(snkd.user.company.get, params);
};

// 修改我在企业中的名字
export const editMyName = (params) => {
  return axios.post(snkd.user.user.editMyName, params);
};

// 获取用户所具有的企业列表
export const getCompanyList = (params = {}) => {
  return axios.post(snkd.user.company.list, params);
};

// 添加企业
export const addCompany = (params) => {
  return axios.post(snkd.user.company.add, params);
};

// 退出登录
export const logout = (params = {}) => {
  return axios.post(snkd.user.login.logout, params);
};

// 获取权限
export const getPermissions = () => {
  const companyInfo = getStorage("COMPANYINFO");
  return axios.post(snkd.user.role.permissions, {
    companyId: companyInfo ? companyInfo.companyId : null,
  });
};
export const getAllCompanyInfo = (params = {}) => {
  return axios.post(snkd.user.company.getCompanyInfo, params);
};

//横沙东滩管理系统
export const hsLoginService = (params) => {
  return axios.post(snkd.user.hsLogin.login, params);
};
